<template>
  <div
    class="primary-select"
    :class="{
      focused: isFocus,
      disabled: disable,
      error: errText,
      success: success,
    }"
  >
    <div class="error-text" v-if="errText">
      {{ errText }}
    </div>
    <div class="wrap">
      <slot />
      <div class="icon" v-if="iconPath">
        <svg
          width="34"
          height="34"
          viewBox="0 0 34 34"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            :d="iconPath"
            fill="#377DFF"
          />
        </svg>
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, ref } from "vue";

const isFocus = ref(false);

// const emit = defineEmits(["input"]);

defineProps({
  iconPath: String,
  errText: String,
  disable: Boolean,
  success: Boolean,
});
</script>
<style lang="scss">
.primary-select {
  width: 100%;
  .wrap {
    height: max-content;
    position: relative;
  }

  &:hover {
    select {
      box-shadow: 0rem 0.5rem 1.75rem -0.38rem rgba(24, 39, 75, 0.12),
        0rem 1.13rem 5.5rem -0.25rem rgba(24, 39, 75, 0.14);
    }
  }

  .icon {
    width: 2.125rem;
    height: 2.125rem;
    position: absolute;
    top: 50%;
    right: 1.625rem;
    transform: translateY(-50%);
  }

  &.error {
    select {
      border-color: var(--error-color);
      color: var(--error-color);

      &:focus {
        color: var(--dark-blue);
      }
    }

    svg {
      path {
        fill: var(--error-color);
      }
    }
  }

  &.disabled {
    svg {
      path {
        fill: var(--disabled-color);
      }
    }
  }

  &.focused {
    svg {
      path {
        fill: var(--primary-blue);
      }
    }
  }

  &.success {
    select {
      color: var(--success-color);
      border-color: var(--success-color);

      &:focus {
        border-color: var(--primary-blue);
        color: var(--dark-blue);
      }
    }

    svg {
      path {
        fill: var(--success-color);
      }
    }
  }

  select {
    width: 100%;
    background: #f3f5f8;
    border-radius: 0.625rem;
    outline: none;
    font-weight: 500;
    font-size: 1em;
    line-height: 180%;
    padding: 1.25rem 1.625rem;
    color: var(--dark-blue);
    border: 0.0625rem solid transparent;
    transition: all 0.3s ease;

    &:focus {
      border-color: var(--primary-blue);
    }

    &:focus ~ svg {
      path {
        fill: var(--error-color);
      }
    }

    &:disabled {
      color: var(--disabled-color);
    }

    &::placeholder {
      font-family: "Inter", sans-serif;
      font-weight: 500;
      font-size: 1em;
      line-height: 180%;
      color: var(--disabled-color);
    }
  }
  .error-text {
    font-weight: 500;
    font-size: 1em;
    line-height: 180%;
    color: var(--error-color);
    margin-bottom: 0.75rem;
  }
}

@media screen and (max-width: 768px) {
  .primary-select {
    .icon {
      width: 1.4375rem;
      height: 1.4375rem;
    }

    select {
      font-size: 0.9rem;
    }
  }
}
</style>
